import { render, staticRenderFns } from "./GetProductCategory.vue?vue&type=template&id=0765b5be&"
import script from "./GetProductCategory.vue?vue&type=script&lang=js&"
export * from "./GetProductCategory.vue?vue&type=script&lang=js&"
import style0 from "./GetProductCategory.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports